import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Link,
  Checkbox,
  FormControlLabel,
  Box
} from '@mui/material';

const UserAgreementDialog = ({ open, onAccept, onPrivacyClick, onTermsClick }) => {
  const [agreed, setAgreed] = useState(false);

  const handleAgreeChange = (event) => {
    setAgreed(event.target.checked);
  };

  const handleAccept = () => {
    if (agreed) {
      onAccept();
    }
  };

  return (
    <Dialog open={open} onClose={() => {}} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        ¡Bienvenido a MisBolos!
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" paragraph>
          Al continuar, aceptas nuestros{' '}
          <Link href="#" onClick={onTermsClick} sx={{ cursor: 'pointer' }}>
            Términos y Condiciones
          </Link>{' '}
          y nuestra{' '}
          <Link href="#" onClick={onPrivacyClick} sx={{ cursor: 'pointer' }}>
            Política de Privacidad
          </Link>
          . Tu perfil se creará con los datos básicos de tu cuenta de Google. Podrás modificar o eliminar tu cuenta en cualquier momento desde la app o escribiéndonos a{' '}
          <Link href="mailto:contact@misbolos.com" color="primary">
            contact@misbolos.com
          </Link>
          .
        </Typography>

        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreed}
                onChange={handleAgreeChange}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                He leído y acepto los{' '}
                <Link href="#" onClick={onTermsClick} sx={{ cursor: 'pointer' }}>
                  Términos y Condiciones
                </Link>{' '}
                y la{' '}
                <Link href="#" onClick={onPrivacyClick} sx={{ cursor: 'pointer' }}>
                  Política de Privacidad
                </Link>
                .
              </Typography>
            }
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', p: 2 }}>
        <Button
          onClick={handleAccept}
          disabled={!agreed}
          variant="contained"
          sx={{
            backgroundColor: '#4285F4',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#357ae8',
            },
            borderRadius: 3,
            paddingX: 4,
            paddingY: 1,
            boxShadow: '0 4px 10px rgba(66, 133, 244, 0.3)',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '1.1rem',
          }}
        >
          Aceptar y continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserAgreementDialog;